const ThemeOverrides = {
	colors: {
		primary: {
			100: '#4b889e',
			200: '#3d7c93',
			300: '#317289',
			400: '#25667d',
			500: '#1c5c73', // default for buttons
			600: '#145066',
			700: '#0d4458',
			800: '#083849',
			900: '#042d3b',
		},
		secondary: {
			500: '#8ad2eb', // default for buttons
		},
		selected: '#ff0:alpha.20',
		hover: '#000:alpha.10',
		selectedHover: '#cc0',
		unselected: '#bbb',
		disabled: '#ccc',
		control: '#1B518C',
		vip: '#3a78bc',
		navBlue: '#3b82f6',
		warning: '#d92b2b',
		warningHover: '#af1313',
		orange: '#de9000',
		greens: {
			100: '#6cbc6b',
			200: '#51a850',
			300: '#429d41',
			400: '#2d8b2c',
			500: '#187917',
			600: '#127010',
			700: '#0b610a',
			800: '#065005',
			900: '#033d02',
		},
	},
	// config: {
	// 	initialColorMode: 'dark',
	// },
	Components: {
		Modal: {
			baseStyle: {
				_web: {
					zIndex: '100000',
					position: 'absolute',
				},
			},
		},
		Select: {
			defaultProps: {
				h: 50,
				flex: 1,
				bg: '#fff',
				borderWidth: 1,
				borderColor: '#000',
				isDisabled: false,
			},
		},
		Icon: {
			defaultProps: {
				size: 'md',
				color: '#fff',
			},
		},
		Input: {
			variants: {
				form: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					return {
						autoCapitalize: 'none',
						mb: 4,
						w: '100%',
						h: '50px',

						// BEGIN Taken from variant 'filled'
						bg: props.bg || (isLightMode ? 'muted.200' : 'muted.600'),
						borderWidth: '1',
						borderColor: 'transparent',
						_hover: {
							bg: isLightMode ? 'muted.200' : 'muted.700',
						},
						// END
					};
				},
			},
			defaultProps: {
				size: 'xl',
			},
		},
		Button: {
			variants: {
				footer: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						flex: 1,
						_text: {
							color: '#fff',
						},
						alignSelf: 'center',
						alignItems: 'center',
						justifyContent: 'center',

						// BEGIN Taken from variant 'solid'
						_web: {
							outlineWidth: '0'
						},
						bg: c + '.800',
						_hover: {
							bg: c + '.600'
						},
						_pressed: {
							bg: c + '.700'
						},
						_focus: {
							bg: c + '.600'
						},
						_loading: {
							bg: isLightMode ? 'warmGray.50' : c + '.300',
							opacity: '50'
						},
						_disabled: {
							_text: {
								color: '#000',
							},
							bg: isLightMode ? 'trueGray.400' : 'trueGray.600',
						},
						// END
					};
				},
				solid2: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						_text: {
							color: '#fff',
						},
						// BEGIN Taken from variant 'solid'
						_web: {
							outlineWidth: '0'
						},
						bg: 'trueGray.200',
						borderColor: c + '.800',
						borderWidth: 1,
						_hover: {
							bg: 'trueGray.400'
						},
						_pressed: {
							bg: 'trueGray.700'
						},
						_focus: {
							bg: 'trueGray.600',
						},
						_loading: {
							bg: isLightMode ? 'warmGray.50' : c + '.300',
							opacity: '50'
						},
						_disabled: {
							_text: {
								color: '#000',
							},
							bg: isLightMode ? 'trueGray.400' : 'trueGray.600',
						},
						// END
					};
				},
				money: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						alignSelf: 'center',
						alignItems: 'center',
						justifyContent: 'center',
						color: 'greens.200',
						borderColor: 'greens.200',
						borderWidth: 2,
						borderRadius: 'xl',
						bg: '#fff',
					};
				},
			},
			defaultProps: {
				size: 'lg',
			},
		},
		IconButton: {
			variants: {
				footer: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						flex: 1,
						alignSelf: 'center',
						alignItems: 'center',
						justifyContent: 'center',

						// BEGIN Taken from variant 'solid'
						_web: {
							outlineWidth: '0'
						},
						bg: c + '.800',
						_hover: {
							bg: c + '.600'
						},
						_pressed: {
							bg: c + '.700'
						},
						_focus: {
							bg: c + '.600'
						},
						_loading: {
							bg: isLightMode ? 'warmGray.50' : c + '.300',
							opacity: '50'
						},
						_disabled: {
							bg: isLightMode ? 'trueGray.400' : 'trueGray.600',
						},
						// END
					};
				},
				solid2: (props) => {
					const c = props.colorScheme,
						m = props.colorMode,
						isLightMode = m === 'light';
					
					return {
						// BEGIN Taken from variant 'solid'
						_web: {
							outlineWidth: '0'
						},
						bg: 'trueGray.200',
						borderColor: c + '.800',
						borderWidth: 1,
						_hover: {
							bg: 'trueGray.400'
						},
						_pressed: {
							bg: 'trueGray.700'
						},
						_focus: {
							bg: 'trueGray.600',
						},
						_loading: {
							bg: isLightMode ? 'warmGray.50' : c + '.300',
							opacity: '50'
						},
						_disabled: {
							bg: isLightMode ? 'trueGray.400' : 'trueGray.600',
						},
						// END
					};
				},
			},
			defaultProps: {
				size: 'lg',
			},
		},
	},
};
export default ThemeOverrides;
